<script lang="ts">
    import { applicationConfigStore } from '../stores/applicationConfigStore'
    import { onMount } from 'svelte'
    import SourceCard from './SourceCard.svelte'
    import type { ISourceSettings } from '../lib/types'

    export let keys
    export let handleKeyGeneration

    $: updateApiKeys = keys.slice().forEach((e) => {
        let settingIndex = sourceSettings.findIndex((item) => {
            return e.type === item.type
        })

        if (settingIndex === -1) {
            return false
        }

        sourceSettings[settingIndex].key = e.apiKey
    })

    let sourceSettings: ISourceSettings[] = [
        {
            type: 'chat',
            width: 1920,
            height: 1080,
            title: 'Twitch chat',
            url: `${$applicationConfigStore.baseUrl}/chat-source`,
            method: handleKeyGeneration,
            key: '',
        },
        {
            type: 'hypetrain',
            width: 1920,
            height: 1080,
            title: 'Hypetrain',
            url: `${$applicationConfigStore.baseUrl}/hype-source`,
            method: handleKeyGeneration,
            key: '',
        },
    ]
</script>

<div class="grid md:grid-cols-2 sm:grid-cols-1 gap-5">
    {#if sourceSettings.length}
        {#each sourceSettings as setting}
            <SourceCard {setting} />
        {/each}
    {/if}
</div>
